import { action, observable, toJS } from 'mobx'
import Api from '@api/localMerchant/NameCard'
import { hashHistory } from 'react-router'
export default class {
  constructor(props) {
    this.initData = props
  }

  @observable step = +this.initData.step
  @observable atlas_id = this.initData.id
  @observable data = {}

  @action
  handleStep = step => () => {
    this.step = step
  }
  @action
  backList = () => {
    hashHistory.replace('/localMerchant/atlasManage')
  }
  @action
  saveAtlas = async values => {
    const params = { ...toJS(values) }
    const { success, data } = this.atlas_id
      ? await Api.editPhoto({ id: this.atlas_id, ...params })
      : await Api.addPhoto(params)
    if (success) {
      this.atlas_id = data
      this.handleStep(2)()
    }
  }
}
